export class AuthResult {
  public exp: number
  public token: string
}
